import PositiveIntegerInput from './PositiveIntegerInput';

export default PositiveIntegerInput;
